<ng-container *ngIf="timeOffPolicy"
    ><form #form="ngForm" invalidControlScroll>
        <app-accrual-settings-update-card [timeOffPolicy]="timeOffPolicy"></app-accrual-settings-update-card>
        <ng-container *ngIf="timeOffPolicy && !timeOffPolicy?.isUnlimited">
            <app-amount-accrued-per-year-update-card
                #amountAccruedPerYearUpdateCardComponent
                (onChange)="onUpdate()"
                (onSeniorityOverrideChange)="onSeniorityOverrideChange($event)"
                [timeOffPolicy]="timeOffPolicy"
                [unitOfTime]="timeOffType.unitOfTimePluralTranslation"
            ></app-amount-accrued-per-year-update-card>
            <app-accrual-schedule-update-card
                (onChange)="onUpdate()"
                [timeOffPolicy]="timeOffPolicy"
            ></app-accrual-schedule-update-card>
            <app-request-rules-update-card
                [timeOffRequestRule]="timeOffRequestRules"
                [unitOfTime]="timeOffType.unitOfTimePluralTranslation"
                (onChange)="updateTimeOffRequestRules($event)"
            ></app-request-rules-update-card>
        </ng-container></form
></ng-container>
